/**
 * 密码安全等级
 */
export var PasswordSecurityLevel;
(function (PasswordSecurityLevel) {
    PasswordSecurityLevel[PasswordSecurityLevel["LOW"] = 1] = "LOW";
    PasswordSecurityLevel[PasswordSecurityLevel["MIDDLE"] = 2] = "MIDDLE";
    PasswordSecurityLevel[PasswordSecurityLevel["HIGH"] = 3] = "HIGH";
})(PasswordSecurityLevel || (PasswordSecurityLevel = {}));
export var SocialConnectionProvider;
(function (SocialConnectionProvider) {
    SocialConnectionProvider["ALIPAY"] = "alipay";
    SocialConnectionProvider["GOOGLE"] = "google";
    SocialConnectionProvider["WECHATPC"] = "wechat:pc";
    SocialConnectionProvider["WECHATMP"] = "wechat:webpage-authorization";
    SocialConnectionProvider["WECHAT_MINIPROGRAM"] = "wechat:miniprogram:default";
    SocialConnectionProvider["WECHAT_MINIPROGRAM_QRCODE"] = "wechat:miniprogram:qrconnect";
    SocialConnectionProvider["WECHAT_MINIPROGRAM_APPLAUNCH"] = "wechat:miniprogram:app-launch";
    SocialConnectionProvider["WECHATMOBILE"] = "wechat:mobile";
    SocialConnectionProvider["GITHUB"] = "github";
    SocialConnectionProvider["QQ"] = "qq";
    SocialConnectionProvider["WECHATWORK_ADDRESS_BOOK"] = "wechatwork:addressbook";
    SocialConnectionProvider["WECHATWORK_CORP_QRCONNECT"] = "wechatwork:corp:qrconnect";
    SocialConnectionProvider["WECHATWORK_SERVICEPROVIDER_QRCONNECT"] = "wechatwork:service-provider:qrconnect";
    SocialConnectionProvider["DINGTALK"] = "dingtalk";
    SocialConnectionProvider["WEIBO"] = "weibo";
    SocialConnectionProvider["APPLE"] = "apple";
    SocialConnectionProvider["APPLE_WEB"] = "apple:web";
    SocialConnectionProvider["LARK_PUBLIC"] = "lark-public";
    SocialConnectionProvider["LARK_INTERNAL"] = "lark-internal";
    SocialConnectionProvider["BAIDU"] = "baidu";
    SocialConnectionProvider["LINKEDIN"] = "linkedin";
    SocialConnectionProvider["SLACK"] = "slack";
    SocialConnectionProvider["YIDUN"] = "yidun";
    SocialConnectionProvider["QINGCLOUD"] = "qingcloud";
    SocialConnectionProvider["FACEBOOK"] = "facebook";
})(SocialConnectionProvider || (SocialConnectionProvider = {}));
export var Protocol;
(function (Protocol) {
    Protocol["OIDC"] = "oidc";
    Protocol["OAUTH"] = "oauth";
    Protocol["SAML"] = "saml";
    Protocol["CAS"] = "cas";
    Protocol["AZURE_AD"] = "azure-ad";
})(Protocol || (Protocol = {}));
export var AppPasswordStrengthLimit;
(function (AppPasswordStrengthLimit) {
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["NoCheck"] = 0] = "NoCheck";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["Low"] = 1] = "Low";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["Middle"] = 2] = "Middle";
    AppPasswordStrengthLimit[AppPasswordStrengthLimit["High"] = 3] = "High";
})(AppPasswordStrengthLimit || (AppPasswordStrengthLimit = {}));
export var RegisterMethods;
(function (RegisterMethods) {
    RegisterMethods["Email"] = "email";
    RegisterMethods["Phone"] = "phone";
})(RegisterMethods || (RegisterMethods = {}));
export var LoginMethods;
(function (LoginMethods) {
    LoginMethods["LDAP"] = "ldap";
    LoginMethods["AppQr"] = "app-qrcode";
    LoginMethods["Password"] = "password";
    LoginMethods["PhoneCode"] = "phone-code";
    LoginMethods["WxMinQr"] = "wechat-miniprogram-qrcode";
    LoginMethods["AD"] = "ad"; // 对应企业身份源的 Windows AD 登录
})(LoginMethods || (LoginMethods = {}));
export var OIDCConnectionMode;
(function (OIDCConnectionMode) {
    OIDCConnectionMode["FRONT_CHANNEL"] = "FRONT_CHANNEL";
    OIDCConnectionMode["BACK_CHANNEL"] = "BACK_CHANNEL";
})(OIDCConnectionMode || (OIDCConnectionMode = {}));
;
export var SceneType;
(function (SceneType) {
    SceneType["SCENE_TYPE_LOGIN"] = "login";
    SceneType["SCENE_TYPE_REGISTER"] = "register";
    SceneType["SCENE_TYPE_RESET"] = "reset";
    SceneType["SCENE_TYPE_BIND"] = "bind";
    SceneType["SCENE_TYPE_UNBIND"] = "unbind";
    SceneType["SCENE_TYPE_MFA_BIND"] = "mfa-bind";
    SceneType["SCENE_TYPE_MFA_VERIFY"] = "mfa-verify";
    SceneType["SCENE_TYPE_MFA_UNBIND"] = "mfa-unbind";
    SceneType["SCENE_TYPE_COMPLETE_PHONE"] = "complete-phone";
})(SceneType || (SceneType = {}));
export var RelayMethodEnum;
(function (RelayMethodEnum) {
    RelayMethodEnum["WEB_MESSAGE"] = "web_message";
    RelayMethodEnum["FORM_POST"] = "form_post";
    RelayMethodEnum["QUERY"] = "query";
})(RelayMethodEnum || (RelayMethodEnum = {}));
//# sourceMappingURL=types.js.map